import React, { FC } from 'react';
import * as classes from './UserInfo.module.scss';
import CalendarIcon from '../../../../../assets/icons/inline/calendar.inline.svg';
import MailIcon from '../../../../../assets/icons/inline/mail.inline.svg';
import PhoneIcon from '../../../../../assets/icons/inline/phone.inline.svg';

import { useTranslation } from 'gatsby-plugin-react-i18next';
import Link from '../../../../Common/Link/Link';

interface UserInfoProps {
  avatar?: string;
  phone: string;
  email: string;
}

const UserInfo: FC<UserInfoProps> = ({ avatar, email, phone }) => {
  const { t } = useTranslation();
  return (
    <div className={classes.wrapper}>
      {!!avatar && (
        <div className={classes.pictureWrapper}>
          <img src={avatar} alt='' />
        </div>
      )}
      <ul className={classes.contactsWrapper}>
        <li>
          <PhoneIcon />
          <a href={`tel:${phone}`}>{phone}</a>
        </li>
        <li>
          <MailIcon />
          <a href={`mailto:${email}`}>{t('homePage.infoSection.sendEmail')}</a>
        </li>
        <li>
          <CalendarIcon />
          <Link path={'/get-in-touch'}>{t('homePage.infoSection.workSchedule')}</Link>
        </li>
      </ul>
    </div>
  );
};

export default UserInfo;
